import templateUrl from 'emun.salesrep/subrep-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
//import RegionPrompt from "emun.salesrep/territory-manager/region/region-prompt";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";

class SubRepListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QuerySubReps.json?RolesIn=SubRep',
			autoLoad: true,
			hideLeftNav: true
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("subrepSaved", () => $ctrl.query.load(true));
    }
	//create() {
	//	const $ctrl = this;
	//	RegionPrompt.open({ region: "", regionId: "" });
	//}
	create() {
		const $ctrl = this;
		$ctrl.$state.transitionTo("subrep", { subrepId: 'create' });
	}

	//edit(region) {
	//	const $ctrl = this;
	//	RegionPrompt.open({ region: region, regionId: region.id });
	//}

	delete(subrep) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete " + subrep.email, "Delete Sub Rep?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteUser.json", subrep)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let SubrepList = {
	controller: SubRepListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default SubrepList;
